export const JournalLabel = {
  aje: {
    short: 'RJ',
    full: 'Record',
  },
  rje: {
    short: 'CJ',
    full: 'Classify',
  },
  cje: {
    short: 'EJ',
    full: 'Eliminate',
  },
};

export const ColumnLabel = {
  unadjusted: 'Trial Balance',
  adjusted: 'Journal Entries',
  net: 'Final Trial Balance',
  netEr: 'Final Trial Balance (ER)',
};

export const ExchangeRateLabel = {
  name: 'Name',
};
